var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"containerRef"},[_c('style',{tag:"component"},[_vm._v("\n    "+_vm._s(_setup.dynamicStyles)+"\n  ")]),_vm._v(" "),_c(_setup.props.tag,{ref:"titleRef",tag:"component",class:`text-pressure-title ${_setup.dynamicClassName}`,style:({
      fontFamily: `'${_setup.props.fontFamily}', sans-serif`,
      textTransform: 'uppercase',
      fontSize: _setup.fontSize + 'px',
      lineHeight: _setup.lineHeight,
      transform: `scale(1, ${_setup.scaleY})`,
      transformOrigin: 'center top',
      margin: 0,
      textAlign: 'center',
      userSelect: 'none',
      whiteSpace: 'nowrap',
      fontWeight: 100,
      width: '100%'
    })},_vm._l((_setup.chars),function(char,i){return _c('span',{key:i,ref:(el) => _setup.setSpanRef(el, i),refInFor:true,style:({
        display: 'inline-block',
        color: _setup.props.stroke ? undefined : _setup.props.textColor
      }),attrs:{"data-char":char}},[_vm._v("\n      "+_vm._s(char)+"\n    ")])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }